export default {
  APP: {
    CLOSE: 'Đóng',
    DETAIL: 'Chi tiết',
    CANCEL: 'Hủy',
    SAVE: 'Lưu',
    BACK: 'Trở về',
    ADD: 'Thêm',
    CHANGE_SERVER: 'Đổi máy chủ',
    CURRENT_SERVER: 'Địa chỉ máy chủ hiện tại',
    NEW_SERVER: 'Địa chỉ máy chủ mới',
    REQUIRED: 'không được để trống',
    CANNOT_CONNECT_TO: 'Không thể kết nối đến máy chủ',
    DO_YOU_STILL_WANT_TO_CONTINUE: 'Bạn có chắc chắn tiếp tục',
    LANGUAGE: 'Ngôn ngữ:',
    WARNING: 'Thông báo',
    YES: 'Đồng ý',
    FEEDBACK_TITLE: 'Đội ngũ M-suite trân trọng đóng góp của bạn',
    FEEDBACK_CONTENT: `Vui lòng dành ra 2' để thực hiện một khảo sát ngắn. Phản hồi của bạn sẽ được sử dụng để cải thiện trải nghiệm trên M-suite Agent.`,
    MAYBE_LATER: 'Để sau',
    START_NOW: 'Làm khảo sát',
    SSL_SETTING: 'SSL bỏ qua xác minh không an toàn',
    USE_BYPASS_CHANNEL: 'Sử dụng kênh kết nối thay thế',
    CONTINUE: 'Tiếp tục',
    CHECKING: 'Đang kiểm tra...',
    WELCOME: 'Xin chào',
    VIEW_DETAIL: 'Xem chi tiết',
    COPIED: 'Đã sao chép',
    RATING: 'Bạn đánh giá thế nào về trải nghiệm sử dụng ứng dụng M-Suite?',
    THANKS: 'M-Suite chân thành cảm ơn ý kiến đóng góp của bạn!',
    DELETE: 'Xoá',
    DELETE_REG: 'Xóa đăng ký',
    NOTIFICATION: 'Thông báo',
    LOADING: 'Đang tải danh sách ứng dụng',
    UPDATE: 'Cập nhật',
    UPDATE_APP: 'Cập nhật ứng dụng',
    HAVE_NEW_VERSION: 'Đã có phiên bản mới: {version}',
    PLEASE_CLICK_UPDATE_TO_UPDATE_NEW_VERSION: {
      1: 'Vui lòng bấm nút',
      2: 'Cập nhật',
      3: 'để tải về và cài đặt phiên bản mới.',
    },
    DIRECT_ACCESS_APP: "Ứng dụng truy cập trực tiếp",
    DIRECT_ACCESS_APP_TOOLTIP: "Các ứng dụng có thể được mở bằng cách nhấp chọn trực tiếp.",
    INTERMEDIATE_ACCESS_APP: "Ứng dụng truy cập trung gian",
    INTERMEDIATE_ACCESS_APP_TOOLTIP: "Các ứng dụng được cấu hình đặc biệt, không thể mở trực tiếp mà cần truy cập thông qua ứng dụng trung gian hoặc phương thức truy cập đặc biệt khác. <br>Để biết thêm thông tin, vui lòng liên hệ đầu mối hỗ trợ.",
    SELECT_SERVER_DESC: "Vui lòng chọn máy chủ tại danh sách dưới đây:",
    CONNECTING: "Đang kết nối",
    LOGIN_STEP_DESC: "Bước đăng nhập sẽ được bỏ qua nếu phiên sử dụng ở máy chủ được chọn vẫn còn hiệu lực.",
    ERROR_INTERNET_COMMON: {
      1:"Đã xảy ra lỗi kết nối.",
      2: "Vui lòng kiểm tra lại kết nối Internet hoặc liên hệ với quản trị viên."
    },
    APP_DISCONNECTED: {
      1: "Đã ngắt kết nối M-Suite",
      2: "Bật lại để truy cập danh sách ứng dụng"
    }
  },
  LOGIN: {
    FIRST_TIME_SUB_TITLE: 'Vui lòng nhập địa chỉ máy chủ kết nối M-Suite',
    SELECT_SERVER: 'Chọn máy chủ',
    ADD_SERVER: 'Thêm máy chủ',
    SERVER_NAME: 'Địa chỉ máy chủ',
    SERVER: 'Máy chủ',
    LOADING_DATA: 'Đang tải dữ liệu đăng nhập',
    SELECT_LOGIN_TYPE: 'Tài khoản đăng nhập',
    ACCOUNT_MSUITE: 'Tài khoản M-Suite',
    FORGOT_PASSWORD: 'Quên mật khẩu?',
    FORGOT_PASSWORD_TITLE: 'Khôi phục tài khoản',
    SELECT_MFA: 'CHỌN PHƯƠNG THỨC XÁC THỰC',
    AUTH_METHOD: 'Phương thức xác thực',
    CODE_NOT_RECEIVED: 'Không nhận được mã?',
    RESEND: 'Gửi lại',
    ERROR_SERVER: 'Địa chỉ máy chủ không chính xác',
    SERVER_EXIST: 'Địa chỉ máy chủ đã tồn tại',
    LOGIN_OPTIONS: 'Tùy chọn đăng nhập',
    TWO_FACTOR_AUTHENTICATION: 'Xác thực 2 bước',
    VERIFY_CURRENT_SESSION: 'Xác minh phiên đăng nhập',
    ENTER_USERNAME_RECOVER: 'Nhập tài khoản cần khôi phục',
    USERNAME: 'Tên tài khoản',
    ENTER_USERNAME_FORGOT_PASSWORD: 'Nhập tài khoản cần khôi phục',
    CHANGE_PASSWORD_FOR_ACCOUNT: 'Thay đổi mật khẩu mới cho tài khoản:',
    GO_TO_LOGIN_PAGE: 'Tới trang Đăng nhập',
    BACK_TO_LOGIN_PAGE: 'Về trang Đăng nhập',
    HAD_LOGIN_SESSION: 'Bạn vẫn còn phiên đăng nhập trước đó tại máy chủ này. Bạn có muốn tiếp tục không?',
    SHOW_PASS: "Hiện mật khẩu",
    HIDE_PASS: "Ẩn mật khẩu"
  },
  LAYOUT: {
    CANCEL: "Hủy",
    CHECK_FOR_UPDATES: "Cập nhật",
    CONFIRM: 'Xác nhận',
    CONFIRM_EXIT: "Xác nhận",
    CONFIRM_LOGOUT: "Xác nhận",
    CONFIRM_LOGOUT_ALL_DEVICE: "Thông báo",
    CONNECTION: "Kết nối",
    CONNECTIVITY_LOST: "Mất kết nối",
    DO_YOU_REALLY_WANT_TO_EXIT_THIS_APP: "Bạn chắc chắn muốn thoát ứng dụng M-suite?",
    DO_YOU_REALLY_WANT_TO_EXIT_THIS_PAGE: "Bạn chắc chắn muốn thoát trang này?",
    DO_YOU_REALLY_WANT_TO_LOGOUT_ALL_DEVICES: "Bạn có xác nhận muốn đăng xuất tất cả các thiết bị (ngoại trừ thiết bị này)?",
    DO_YOU_REALLY_WANT_TO_LOGOUT_THIS_APP: "Bạn có chắc chắn muốn đăng xuất và trở về màn hình Đăng nhập?",
    DO_YOU_WANT_TO_LOGOUT_THIS_DEVICE: "Bạn có muốn đăng xuất thiết bị này?",
    EXIT: "Thoát",
    FEEDBACK: "Hòm thư góp ý",
    GUIDE: "Hướng dẫn",
    LOGOUT: "Đăng xuất",
    LOGOUT_ALL: "Đăng xuất",
    LOG_OUT_ALL_DEVICES: "Đăng xuất tất cả thiết bị",
    NOTIFICATION: "Thông báo",
    OPTIONS: "Tuỳ chọn",
    SETTING: "Cài đặt",
    TROUBLESHOOTING_GUIDE: "Hướng dẫn khắc phục vấn đề",
    USER_GUIDE: "Hướng dẫn sử dụng",
    ONLINE: "Đang sử dụng",
    EXPIRED_TOKEN_CONTENT: "Bạn đã đăng xuất khỏi phiên hiện tại",
    BACK_TO_LOGIN_PAGE_AFTER: 'Về trang đăng nhập ({second}s)',
    QRCODE_EXPIRED: "Mã QR đã hết hạn",
    RELOAD_QRCODE: "Hệ thống sẽ tải lại mã QR."
  },
  APPLICATIONS: {
    LIST_APPS: 'Danh sách ứng dụng',
    RECENT_APPS: 'Truy cập gần nhất',
    SEARCH_RESULT: 'Kết quả tìm kiếm',
    NO_SEARCH_RESULT: 'Không tìm thấy ứng dụng',
    TRY_WITH_OTHER_KEYWORD: 'Hãy thử tìm kiếm với từ khóa khác',
    APP_BLANK: 'Danh sách ứng dụng trống',
    START_ALL_APP: 'Bật tất cả ứng dụng',
    CLOSE_ALL_APP: 'Tắt tất cả ứng dụng',
    SEARCH_APPS: 'Tìm ứng dụng',
    LOADING: 'Đang tải'
  },
  SCAN_DEVICE: {
    DEVICE_POLICY: 'Đánh giá An toàn thiết bị',
    ISSUE: 'vấn đề',
    NO_ISSUES: 'Không phát hiện vấn đề',
    DETECTED_ISSUES: 'Phát hiện {issues} vấn đề',
    SCAN: 'Quét',
    SCANNING: 'Đang quét thiết bị',
    VIEW_DETAIL: 'Xem chi tiết'
  },
  POLICIES_BASELINES: {
    STEP: 'Bước',
    SKIP_ACTION: 'Bỏ qua',
    SCAN_DEVICE: 'Quét thiết bị',
    NOTE: 'Lưu ý',
    NOTE_CONTENT: 'Bạn đã khắc phục vấn đề? \n Vui lòng quét thiết bị để cập nhật thay đổi.',
    SCANNING: 'Đang quét',
    BLOCK_NET_POLICY: "Chính sách chặn truy cập Internet",
    BLOCK_NET_POLICY_DESC_1: "Các ứng dụng quan trọng sẽ được áp dụng chính sách <b>chặn truy cập Internet</b> khi bật, nhằm hạn chế tối đa các rủi ro gây mất an toàn thông tin cho hệ thống.",
    BLOCK_NET_POLICY_DESC_2: "Để có thể trở lại truy cập Internet bình thường, vui lòng ngắt kết nối tất cả các ứng dụng có biểu tượng <b>Chặn Internet</b>.",
  },
  SDP_APP: {
     ACCEPT: "Cho phép",
     APP_NAME: "Tên ứng dụng",
     APP_STATUS: "Trạng thái",
     AUTO_START_ALL_APP_AFTER_LOGIN_DESC: "Tự động mở truy cập tất cả ứng dụng trong danh sách sau khi đăng nhập M-Suite",
     BASELINE_ISSUE: "Trạng thái An toàn thiết bị",
     BASELINE_ISSUE_ALERT: "Vi phạm chỉ tiêu An toàn thiết bị",
     BASELINE_ISSUE_SUB_TITLE: "Truy cập bị hạn chế do vi phạm một số Chỉ tiêu An toàn thiết bị được thiết lập bởi Quản trị viên. Để khắc phục vấn đề, vui lòng xử lý theo hướng dẫn dưới đây hoặc liên hệ với Quản trị viên.",
     BLOCK_NETWORK: "Chặn internet",
    DISABLE_CLIPBOARD: "Chặn sao chép",
    DISABLE_DOWNLOAD: "Chặn tải xuống",
    DISABLE_PRINT: "Chặn in ấn",
    CLICK_TO_OPEN: "Nhấn để mở ứng dụng",
    CLOSE_APP_CONNECTION: "Đóng truy cập",
     CLOSE_STATUS: "Đóng truy cập",
     CONNECT_PERMISSION: "Quyền truy cập",
     CONNECT_REQUEST: "Cần quyền truy cập",
     DECLINE: "Không cho phép",
     DETAILS_GUIDELINE: "Hướng dẫn chi tiết",
     DOMAIN: "Tên miền/IP",
     EXPIRED_TIME: "Thời hạn phiên",
     EXPLAIN_CAN_NOT_RESOLVE_APP_PART_1: "Hệ điều hành của bạn không tương thích với một số quy chuẩn/chính sách bảo mật được áp dụng",
     EXPLAIN_CAN_NOT_RESOLVE_APP_PART_2: "Vui lòng liên hệ với admin hệ thống để được hỗ trợ.",
     GO_TO_SETTINGS: "Đi tới Cài đặt",
     HAS_BASELINE_ISSUE: "Không thể mở truy cập ứng dụng do vi phạm Chỉ tiêu an toàn thiết bị.",
     MESSAGE_REQUEST_CONNECT: "Lời nhắn",
     MESSAGE_TO_ADMINISTRATOR: "Trường thông tin này là bắt buộc",
     NEED_APPROVED_MESSAGE: "Bạn cần được cấp quyền để truy cập ứng dụng này.",
     NO_APPROVE_CONNECT_YET: "Ứng dụng chưa được cấp quyền truy cập",
     OPENING_CONNECTION: "Đang mở truy cập...",
     OPEN_APP_CONNECTION: "Mở truy cập ứng dụng",
     OPEN_STATUS: "Đang mở truy cập",
     PENDING_APPROVED_MESSAGE: "Yêu cầu truy cập ứng dụng đã được gửi. Vui lòng chờ Quản trị viên phê duyệt yêu cầu.",
     POLICIES: "Chính sách",
     REFRESH_APPS: "Đang làm mới kết nối",
     REJECT_APP: "Yêu cầu truy cập của bạn đã bị từ chối",
     RENEW_APP_LIST: "Làm mới danh sách ứng dụng",
     REQUEST_CONNECT: "Yêu cầu truy cập",
     RESOLVE: "Xử lý vấn đề",
     SEND_REQUEST: "Gửi yêu cầu",
     SEND_REQUEST_CONNECT_APP: "Gửi yêu cầu truy cập ứng dụng",
     START_ALL_AFTER_LOGIN: "Tự động bật tất cả ứng dụng",
  },
  ACCOUNT: {
    ACCOUNT_INFO: 'Tài khoản',
    ACCOUNT_DETAILS: 'Thông tin tài khoản',
    DISPLAY_NAME: 'Tên hiển thị',
    EMAIL: 'Email',
    PHONE_NUMBER: 'Số điện thoại',
    USER_ID: 'ID người dùng',
    CLIENT_ID: 'Client ID',
  },
  DEVICE: {
    DEVICE_ID: 'ID thiết bị',
  },
  VERIFY_CURRENT_SESSION: {
    PLEASE_WAIT_FOR_A_WHILE: 'Vui lòng đợi một lát',
    CHANGE_SERVER: 'Thay đổi địa chỉ máy chủ',
    CONNECTIVITY_LOST: 'Mất kết nối',
    CONNECTING_TO_SERVER: 'Có thể có một số sự cố khi kết nối với máy chủ',
    SOMETHING_WENT_WRONG: 'Đã xảy ra lỗi!',
    TRY_CONNECTING_TO: 'Đang kết nối đến '
  },
  USERNAME_PASSWORD: {
    USERNAME: 'Tài khoản',
    PASSWORD: 'Mật khẩu',
    OTP: "OTP",
    NEW_PASSWORD: 'Mật khẩu mới',
    ENTER_NEW_PASSWORD: 'Nhập mật khẩu',
    ENTER_NEW_PASSWORD_AGAIN: 'Nhập lại mật khẩu mới',
    REQUIRED: 'không được để trống',
    CANNOT_CONNECT_TO: 'Không thể kết nối đến server',
    DO_YOU_STILL_WANT_TO_CONTINUE: 'Bạn có chắc chắn tiếp tục',
    LOGIN: 'Đăng nhập',
    CONFIRM_PASSWORD_NOT_VALID: 'Mật khẩu nhập lại không trùng khớp',
    PASSWORD_RULES_TITLE: 'Mật khẩu hợp lệ bao gồm:',
    PASSWORD_RULES: {
      AT_LEAST_8_CHARACTERS: 'Ít nhất 08 ký tự.',
      AT_LEAST_A_LOWERCASE: 'It nhất 01 ký tự chữ cái thường (a-z)',
      AT_LEAST_A_UPPERCASE: 'Ít nhất 01 ký tự chữ cái hoa (A-Z)',
      AT_LEAST_A_NUMBER: 'Ít nhất 01 ký tự số (0-9)',
      AT_LEAST_A_SPECIAL_CHARACTER: 'Ít nhất 01 ký tự đặc biệt (! @ # $ % ...).'
    },
    CHANGE_PASSWORD_SUCCESS: 'Đổi mật khẩu thành công',
    ENTER_PASSWORD_TO_CONFIRM: 'Nhập mật khẩu để xác nhận',
    PASSWORD_INCORRECT: 'Thông tin xác thực không đúng'
  },
  TOTP: {
    CLICK_TO_QR_CODE: "Nhấn vào mã QR để hiển thị",
    SETUP_KEY: "Mã thiết lập (Setup key)",
    SETTING_TOTP: 'Thiết lập TOTP',
    SETTING_TOTP_CODE: 'Mã thiết lập TOTP',
    SETTING_TOTP_CODE_NODE: 'Lưu ý: KHÔNG chia sẻ mã cho bất kỳ ai.',
    CODE: 'Mã thiết lập TOTP',
    SETTING_TOTP_CONTENT: {
      1: 'Sử dụng phương thức xác thực TOTP, bạn sẽ nhận mã xác thực (OTP) qua ứng dụng của bên thứ ba (Google Authenticator, Microsoft Authenticator, etc.)',
      2: 'Để có thể sử dụng phương thức này, bạn cần thực hiện thiết lập ban đầu một lần duy nhất (trừ các trường hợp khởi tạo mới tài khoản M-Suite hoặc thay đổi/cài đặt lại ứng dụng TOTP)'
    },
    INTRO_SETTING_TOTP: 'Hướng dẫn thiết lập TOTP',
    COPY: 'Chép vào bộ nhớ tạm',
    COPIED: 'Đã chép vào bộ nhớ tạm',
  },
  PREPARE: {
    RETRY: 'Kết nối lại',
    CONNECTIVITY_LOST: 'Mất kết nối',
    BACK_TO_LOGIN: 'Quay lại đăng nhập',
    CHANGE_SERVER: 'Đổi máy chủ',
    AUTHENTICATING: 'Đang xác thực',
  },
  OTP: {
    NEXT: 'Tiếp theo',
  },
  ENROLLMENT_WAIT: {
    CONFIRM_MESSAGE: 'Bạn có thực sự muốn hủy yêu cầu này không?',
    CONFIRM_TITLE: 'Xác nhận Hủy yêu cầu',
    NO: 'Không',
    YES: 'Có',
    LOGOUT_CONFIRM_MESSAGE: 'Bạn có thực sự muốn đăng xuất?',
    LOGOUT_CONFIRM_TITLE: 'Xác nhận đăng xuất',
    CANCEL: 'Hủy',
    LOGOUT: 'Đăng xuất',
    ENTER_OTP_FOR_AUTO_APPROVED: "Nhập OTP để được tự động phê duyệt",
    RESEND: "Gửi lại",
    WAIT_APPROVE: 'Đang chờ phê duyệt',
    WAIT_APPROVE_CONTENT: 'Yêu cầu kết nối của bạn đã được gửi đến Quản trị viên. Vui lòng chờ phê duyệt trước khi có thể bắt đầu.'
  },
  ENROLLMENT_LAYOUT: {
    REGISTER_CONNECT: 'Đăng ký kết nối'
  },
  ENROLLMENT_RESULT: {
    REGISTRATION_DENIED: 'Yêu cầu bị từ chối',
    YOUR_REGISTRATION_HAD_BEEN_DENIED: 'Quản trị viên đã từ chối yêu cầu kết nối thiết bị của bạn.',
    REQUEST_AGAIN: 'Gửi lại yêu cầu',
    AUTHEN_DEVICE_FAILED: 'Có vấn đề trong quá trình xác thực thiết bị',
    RESOLVE: 'Để khắc phục, vui lòng thực hiện lần lượt các bước sau:',
    RESOLVE_CONTENT_1: 'Tắt ứng dụng M-Suite trên System tray và khởi động lại',
    RESOLVE_CONTENT_2: 'Khởi động lại thiết bị',
    RESOLVE_CONTENT_3: 'Nếu hệ thống vẫn xuất hiện lỗi sau một vài lần thực hiện, hãy liên hệ với Quản trị viên hệ thống để được hỗ trợ.',
    RESOLVE_CONTENT_4: 'Để đăng ký lại thiết bị, vui lòng nhấp ',
    RESOLVE_CONTENT_LINK: 'vào đây.',
    EXIT_APP: 'Thoát ứng dụng',
  },
  ENROLLMENT_PREPARE: {
    EMAIL: 'Email',
    DEVICE_NAME: 'Tên thiết bị',
    IDENTITY_DEVICE: 'Định danh thiết bị',
    MESSAGE: 'Lời nhắn',
    REGISTER: 'Đăng ký kết nối',
    DOMAIN: 'Máy chủ',
    TIME: 'Thời gian',
    HIDE_DETAILS: 'Ẩn chi tiết',
    SHOW_DETAILS: 'Xem chi tiết',
  },
  COMMON_LOCAL_APP_CONNECT: {
    OVERTIME: 'Ứng dụng có thể đã bị đóng. Vui lòng đóng cửa sổ / tab trình duyệt này.Cảm ơn!',
  },
  COMMON_LOCAL_SERVICE_CONNECT: {
    LINUX_COMMAND: 'Hãy thử lệnh này trên bảng điều khiển dành cho quản trị viên để khắc phục sự cố',
    CLICK_TO_RESOLVE: 'Bấm để khắc phục sự cố',
    NOTE: 'Ghi chú',
    CONFIRM_CONTENT: 'Bạn có thể phải cần xác nhận bằng mật khẩu thiết bị này để xử lý vấn đề',
    VIEW_DETAIL_GUIDELINE: 'Xem chi tiết hướng dẫn',
    I_UNDERSTOOD_CONTINUE: 'Tôi đã hiểu & tiếp tục',
    THERE_MAY_HAVE_SOME_TROUBLES_FROM_SERVICE_PROCESS: 'Có thể có một số lỗi khi quá trình kết nối đến tiến trình dịch vụ'
  },
  USER_GUIDE: {
    TABLE_OF_CONTENT: 'Mục lục',
    CONTACT_US: 'Liên hệ',
    SEARCH_PLACEHOLDER: 'Tìm kiếm theo từ khóa...',
    SEARCH_RESULT_FOR: 'Kết quả tìm kiếm cho',
    NO_DATA: 'Không tìm thấy kết quả tương ứng',
    CONTACT_TITLE: 'Liên hệ với Admin hệ thống',
    CONTACT_CONTENT: 'Bạn cần hỗ trợ cài đặt/ khắc phục sự cố? Vui lòng liên hệ theo thông tin sau:',
    CONTACT_EMAIL: 'Email',
    CONTACT_PHONE: 'Số điện thoại',
  },
  ERROR_SERVICE: {
    ERROR_SERVICE_HOST_NAME: 'Không thể kết nối đến máy chủ.Vui lòng kiểm tra đường truyền internet của bạn và thử lại',
    ERROR_SERVICE_SDP_DISCONNECT: 'Không thể kết nối đến máy chủ.Vui lòng kiểm tra đường truyền internet của bạn',
    ERROR_SERVICE_CONNECT_TIMEOUT: 'Đã hết thời gian kết nối cho phép. Vui lòng kiểm tra đường truyền Internet của bạn và thử lại',
    ERROR_SERVICE_GENERAL: "Có lỗi xảy ra. Vui lòng thử lại sau ít phút",
    ERROR_DETAIL: "Chi tiết lỗi",
    ERROR_GATEWAY: "Kết nối tới gateway bị gián đoạn",
    ERROR_BASELINE: "Không thể truy cập ứng dụng do thiết bị vi phạm chính sách",
    ERROR_MAX_CHARACTER: "{name} không được vượt quá {max} ký tự",
    ERROR_SSL_EXPIRED: "Chứng chỉ SSL không tồn tại hoặc đã hết hạn",
    ERROR_UPDATE: "Đã có lỗi xảy ra. Không thể cập nhật ứng dụng"
  },
  COUNT_DOWN: {
    REMAINING_DURATION_TEXT: 'Hết hạn truy cập'
  },
  OPTIONS: {
    // MENU
    LABEL: 'Tuỳ chọn',
    SERVER: 'Máy chủ',
    SERVER_CONFIG: 'Đổi máy chủ',
    VERSION: 'Phiên bản',
    DEVICES_MANAGEMENT: 'Quản lý thiết bị',
    CONTACT_AND_SUPPORT: 'Liên hệ & Hỗ trợ',
    FEEDBACK: 'Hòm thư góp ý',
    OTHERS: 'Tuỳ chọn khác',
    LANGUAGE: 'Ngôn ngữ',
    LOGOUT: 'Đăng xuất',
    EXIT: 'Thoát ứng dụng',
    // FEEDBACK
    YOUR_OPINION: 'Ý kiến của bạn',
    YOUR_OPINION_REQUIRED: 'Vui lòng điền ý kiến của bạn',
    FEEDBACK_DESC: 'Chúng tôi, đội ngũ phát triển Viettel M-Suite, luôn trân trọng ý kiến đóng góp của người dùng sản phẩm. Tất cả phản hồi của quý vị đều sẽ được chúng tôi ghi nhận cẩn thận và làm mục tiêu để cải thiện sản phẩm ngày một tốt hơn. Trân trọng cảm ơn!',
    SEND_FEEDBACK: 'Gửi góp ý',
    SEND_FEEDBACK_SUCCESS: 'Bạn đã gửi góp ý thành công.',
    SEND_OTHER_FEEDBACK: 'Gửi phản hồi khác',
    // UPDATE
    UPDATE_APP: 'Kiểm tra phiên bản',
    NEW_UPDATE_AVAILABLE: 'Phiên bản mới',
    CURRENT_VERSION: 'Phiên bản hiện tại',
    UPDATED_APP: 'Ứng dụng đã được cập nhật',
    UPDATING_APP: 'Đang tải xuống',
    UPDATING_APP_DESC: 'Bạn vẫn có thể tiếp tục sử dụng ứng dụng cho đến khi hoàn tất tải xuống',
    STOP_UPDATE: 'Dừng cập nhật',
    CHECK_UPDATE: 'Kiểm tra cập nhật',
    CHECKING_UPDATE: 'Đang kiểm tra cập nhật',
    UPDATE_NOW: 'Cập nhật ngay',
    UPDATE_CLOSE_BLOCK_NETWORK_APP_INTRO: 'Để có thể kiểm tra và cập nhật phiên bản, cần đóng truy cập các ứng dụng có chính sách chặn Internet.',
    UPDATE_DETAILS: "CHI TIẾT CẬP NHẬT:",
    // LANGUAGE
    CHOOSE_LANGUAGE: 'Thiết lập ngôn ngữ giao diện',
    UPDATE_LANGUAGE: 'Đổi ngôn ngữ',
    // DEVICES
    DEVICE: 'Thiết bị',
    NAME: 'Tên',
    OS: 'Hệ điều hành',
    REGISTRATION_DATE: 'Ngày đăng ký',
    LAST_LOGIN: 'Truy cập cuối',
    DELETE_CONNECTION: 'Xóa đăng ký thiết bị',
    DEVICE_INFO: 'Thông tin thiết bị',
    LOGOUT_ALL_DEVICES: 'Đăng xuất tất cả thiết bị',
    THIS_DEVICE: 'Thiết bị này',
    OTHER_DEVICES: 'CÁC THIẾT BỊ KHÁC',
    RE_LOGIN_AFTER_CHANGE_SERVER: 'Có thể cần đăng nhập lại sau khi đổi máy chủ',
    DELETE_CONNECTION_DESC: 'Quyền kết nối của thiết bị với tất cả các máy chủ sẽ bị xóa.',
    CANCEL_CONNECT_PERMISSION_DEVICE: "Quyền kết nối của thiết bị trên máy chủ: {domainName} sẽ bị hủy bỏ.",
    DO_YOU_WANT_TO_LOGOUT_THIS_DEVICE: "Bạn có muốn đăng xuất thiết bị?",
    //SUPPORT
    EMAIL: "Hòm thư điện tử",
    CONTACT: "Tổng đài hỗ trợ",
    INSTRUCTIONS: "Hướng dẫn",
    INSTRUCTIONS_FOR_USE: "Hướng dẫn sử dụng",
    TROUBLESHOOTING_GUIDE: "Hướng dẫn khắc phục vấn đề",
  },
  BASELINE: {
    BASELINE_DESC: "Các tiêu chuẩn về An toàn thiết bị dưới đây được Quản trị viên quy định nhằm bảo đảm an toàn cho hệ thống nội bộ khi kết nối từ xa.",
    ONLY_SHOW_TEXT: "Chỉ hiển thị tiêu chí vi phạm"
  }
};
